import { Component, Input, Output, EventEmitter, ChangeDetectorRef } from '@angular/core';
import { FormSectionHandler } from '../../entities/entity.handler';


export interface AdminSectionEditorAction {
    id?: string;
    icon?: string;
    name?: string;
    showAlways?: boolean;
    showEditing?: boolean;
}

@Component({
    selector: 'key-admin-section-editor',
    templateUrl: './section.component.html',
    styleUrls: ['./section.component.scss'],
    standalone: false
})
export class AdminSectionEditorComponent {

    @Input() handler: FormSectionHandler<any, any>;
    @Input() entity: any;
    @Input() editing: boolean;
    @Input() editable: boolean;
    @Input() errorMessage: string;
    @Input() saveable = false;
    @Input() showHeader = true;
    @Input() showButtons = true;

    @Input() actions: AdminSectionEditorAction[] = [];

    @Output() onEdit = new EventEmitter();
    @Output() onSave = new EventEmitter();
    @Output() onCancel = new EventEmitter();
    @Output() onAction = new EventEmitter<string>();

    constructor(private ref: ChangeDetectorRef) {    }

    async onIconClicked() {
        if (this.handler.onIconClicked) {
            await this.handler.onIconClicked(this.entity);
            this.ref.markForCheck();
        }
    }

    get staticActions(): AdminSectionEditorAction[] {
        return (this.actions || []).filter(x => x.showAlways);
    }

    get editingActions(): AdminSectionEditorAction[] {
        return (this.actions || []).filter(x => x.showEditing !== false);
    }


}
